import InquiryComments from '@activities/customerService/InquiryLogActivity/components/InquiryComments';
import useInquiry from '@activities/customerService/InquiryLogActivity/hooks/useInquiry';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import InquiryContent from './components/InquiryContent';
import InquiryFooter from './components/InquiryFooter';
import InquiryHeader from './components/InquiryHeader';
import InquiryNavigator from './components/InquiryNavigator';

interface Params {
    inquiryId: string;
}

const InquiryLogActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { inquiryId } = params;
  const { inquiry, isLoading } = useInquiry(inquiryId);
  return (
        <AppScreen>
            {isLoading && (
                <Loading/>
            )}
            {inquiry && (
                <CtaLayout header={<Header title='1:1 문의' />}
                           footer={<InquiryFooter inquiry={inquiry}/>} >
                    <Container>
                        <InquiryHeader inquiry={inquiry}/>
                        <InquiryContent inquiry={inquiry}/>
                        <InquiryComments inquiry={inquiry}/>
                        <InquiryNavigator/>
                    </Container>
                </CtaLayout>
            )}
        </AppScreen>
  );
};

const Container = styled.div`
    width: 100%;
    min-height: 100%;
    position: relative;
`;

export default InquiryLogActivity;
